var StatCounterBlock = /** @class */ (function () {
    function StatCounterBlock(element) {
        this.statCounterBlock = element;
        this.statisItemsContainer = this.statCounterBlock.querySelector('.statistic-items');
        this.statisticItems = Array.from(this.statisItemsContainer.querySelectorAll('.statistic-item'));
        this.observer = null;
        this.lang = document.querySelector('html').getAttribute('lang');
        this.animationDuration = 2000;
        this.initIntersectionObserver();
    }
    StatCounterBlock.prototype.handleIntersection = function (entries) {
        var _this = this;
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                _this.animateCounter();
                if (_this.observer) {
                    _this.observer.disconnect();
                    _this.observer = null; // Set observer to null
                }
            }
        });
    };
    StatCounterBlock.prototype.initIntersectionObserver = function () {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
            root: null,
            threshold: 0.5,
        });
        this.observer.observe(this.statisItemsContainer);
    };
    StatCounterBlock.prototype.animateCounter = function () {
        var _this = this;
        var startTime = performance.now();
        var endTime = startTime + this.animationDuration;
        var self = this;
        var updateCounters = function (timestamp) {
            var progress = Math.min(1, (timestamp - startTime) / _this.animationDuration);
            self.statisticItems.forEach(function (element, index) {
                var numberContainer = element.querySelector('[data-target-value]');
                var targetValue = parseFloat(numberContainer.dataset.targetValue);
                var isInt = Number(targetValue) === targetValue && targetValue % 1 === 0;
                var currentValue = Math.floor(progress * targetValue);
                if (!isInt) {
                    var decimalPointCount = targetValue.toString().split('.')[1].length;
                    currentValue = parseInt(Number(progress * targetValue).toFixed(decimalPointCount));
                }
                numberContainer.textContent = new Intl.NumberFormat(self.lang).format(currentValue);
            });
            if (progress < 1) {
                requestAnimationFrame(updateCounters);
            }
        };
        requestAnimationFrame(updateCounters);
    };
    return StatCounterBlock;
}());
var statCounterBlocks = document.querySelectorAll('[data-stat-counter-block]');
statCounterBlocks.forEach(function (statCounterBlock) { return new StatCounterBlock(statCounterBlock); });
